import { useCommoditiesQuery } from "@/pages/sy/hooks/queries/useCommoditiesQuery";
import { ErrorModal } from "@dexteel/mesf-core";
import { useState } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useParams } from "react-router-dom";
import { TableCommodity } from "../components/TableCommodity";

export const CommodityPage = () => {
  const { commodityId } = useParams();
  const [error, setError] = useState("");

  const { data: commodities = [], isLoading } = useCommoditiesQuery(
    false,
    (err) => setError(err.message),
  );

  return (
    <>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} sx={{ m: 0 }}>
          <Paper
            elevation={1}
            sx={{
              width: "100%",
              py: 1.25,
              pb: 2.5,
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableCommodity
              commodityId={commodityId}
              isLoading={isLoading}
              commodities={commodities}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
